import { b3dmHeaderSize, getFeatureAndBatchByteLength } from './header';
import { B3dmHeader } from './types';

export const extractB3dmGlb = (b3DmBuffer: Buffer, b3DmHeader: B3dmHeader) => {
  const glbByteOffset = b3dmHeaderSize + getFeatureAndBatchByteLength(b3DmHeader);

  return new Uint8Array(
    b3DmBuffer.buffer,
    b3DmBuffer.byteOffset + glbByteOffset,
    b3DmBuffer.byteLength - glbByteOffset,
  );
};
